// Reads the logged-in user's info (saved at login) from localStorage.
// Used to conditionally show/hide admin-only UI elements.
export function getCurrentUser() {
  const stored = localStorage.getItem('user');
  return stored ? JSON.parse(stored) : null;
}

export function isAdmin() {
  const user = getCurrentUser();
  return user?.role === 'admin';
}